/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Product } from 'src/app/models/products';
import { FeedbackService } from 'src/app/services/feedback-service/feedback.service';
import { ProductsService } from 'src/app/services/products/products.service';
import { SettingsService } from '@windriver/ui';

@Component({
  selector: 'wsn-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  products: Product[];
  selectedProduct: Product;
  feedback = '';
  user: any;
  @ViewChild('confirmDialog', { static: true }) confirmDialog: TemplateRef<any>;

  constructor(
    private productService: ProductsService,
    private feedbackService: FeedbackService,
    private settingsService: SettingsService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.productService.getProducts().subscribe((p) => (this.products = p));
    this.settingsService.getAllSettings().subscribe((u) => (this.user = u));
  }

  onSelectProduct(product: Product) {
    this.selectedProduct = product;
  }

  onSubmit() {
    this.feedbackService
      .submitFeedback({
        user: this.user?.username,
        product: this.selectedProduct.name,
        feedback: this.feedback
      })
      .subscribe(() => console.log('Success'));

    this.selectedProduct = undefined;
    this.feedback = '';

    this.dialog.open(this.confirmDialog);
  }
}
